// import FormPasswordInput from '../resetPasswordPage/FormPasswordInput';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    Typography,
    makeStyles
} from '@material-ui/core';
import FormPasswordInput from '../resetPasswordPage/FormPasswordInput';
import config from '../../config/config.json';

const host = config.production.host;

const useStyles = makeStyles((theme) => ({
    formContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: '20px auto',
        width: 300,
    },
    textField: {
        marginBottom: theme.spacing(2),
        width: '100%',
    },
    button: {
        color: "white",
        backgroundColor: "orange",
        width: '100%',
        marginTop: theme.spacing(2),
    },
}));

const GetEditPassword = ({ hash }) => {
    const classes = useStyles();
    const [verificationStatus, setVerificationStatus] = useState('');
    const [showResetForm, setShowResetForm] = useState(false);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const handleShowPasswordClick = () => {
        setShowPassword(!showPassword);
    };

    useEffect(() => {
        const verifyHash = async () => {
            try {
                let data = JSON.stringify({ "hash": hash });

                let config = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: host + '/checkout/',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data: data
                };

                const response = await axios.request(config);

                setVerificationStatus(response.data.status);

                if (response.data.status === "ok") {
                    setShowResetForm(true);
                } else {
                    setShowResetForm(false);
                }
            } catch (error) {
                console.error('Errore durante la verifica dell\'hash:', error);
                setVerificationStatus('error');
            }
        };

        verifyHash();
    }, [hash]);

    return (
        <div>
            {showResetForm && (
                /* Richiamo il fom per il cambio password */
                <FormPasswordInput hash={hash} />
            )}
            {!showResetForm && (
                <Typography variant="body1" color="error">
                    Accesso negato
                </Typography>
            )}
        </div>
    );
};

export default GetEditPassword;
